import React, { Component } from 'react';
import StepperEvent from '../../../../Components/StepperEvent';
import Table from './../../../../Components/Table';
import { Card, CardBody } from 'reactstrap';
import './styles.css';
import TablesEvent from './tablesEvent';
import { withNamespaces } from 'react-i18next';

class Events extends Component {
  state = {
    allSteps: [],
    allTables: [
      {
        columns: [
          { label: this.props.t("event_description"), key: 'EventDescription', idTh: 'firstTh', idTd: 'firstTd' },
          { label: this.props.t("event_date"), key: 'EventDate' },
          { label: this.props.t("name"), key: 'CategoryResponsable' },
          { label: this.props.t("update_date"), key: 'CreateDate' },
          // { label: 'updated_on', key: 'CreateDate', idTh: 'firstTh', idTd: 'firstTd' },



        ],
        data: [],
        eventType: this.props.t("events")
      },
    ],
    steps: [
    ],
    columns: [
      { label: this.props.t("event_description"), key: 'EventDescription', idTh: 'firstTh', idTd: 'firstTd' },
      { label: this.props.t("event_date"), key: 'EventDate' },
      // { label: 'Categoría de Responsable', key: 'CategoryResponsable',idTh: 'firstTh', idTd: 'firstTd' },
      { label: this.props.t("origin"), key: 'Origin' },
      { label: this.props.t("update_date"), key: 'CreateDate' },
    ],
    tables: [
      // {
      //   columns: [
      //     { label: 'Descripción del Evento', key: 'Descripcion', idTh: 'firstTh', idTd: 'firstTd' },
      //     { label: 'Fecha del Evento', key: 'Fecha', idTh: 'firstTh', idTd: 'firstTd' },
      //     { label: 'Categoría de Responsable', key: 'Categoria', idTh: 'firstTh', idTd: 'firstTd' },
      //     { label: 'Origen', key: 'Nombre', idTh: 'firstTh', idTd: 'firstTd' },
      //     { label: 'Fecha de Creación', key: 'FechaActualizacion', idTh: 'firstTh', idTd: 'firstTd' },
      //   ],
      //   data: [
      //   ],
      //   title: 'Reserva'
      // },
      // {
      //   columns: [
      //     { label: 'Descripción del Evento', key: 'Descripcion', idTh: 'firstTh', idTd: 'firstTd' },
      //     { label: 'Fecha del Evento', key: 'Fecha', idTh: 'firstTh', idTd: 'firstTd' },
      //     { label: 'Categoría de Responsable', key: 'Categoria', idTh: 'firstTh', idTd: 'firstTd' },
      //     { label: 'Origen', key: 'Nombre', idTh: 'firstTh', idTd: 'firstTd' },
      //     { label: 'Fecha de Creación', key: 'FechaActualizacion', idTh: 'firstTh', idTd: 'firstTd' },
      //   ],
      //   data: [
      //   ],
      //   title: 'Embarques de Exportación'
      // },
      // {
      //   columns: [
      //     { label: 'Descripción del Evento', key: 'Descripcion', idTh: 'firstTh', idTd: 'firstTd' },
      //     { label: 'Fecha del Evento', key: 'Fecha', idTh: 'firstTh', idTd: 'firstTd' },
      //     { label: 'Categoría de Responsable', key: 'Categoria', idTh: 'firstTh', idTd: 'firstTd' },
      //     { label: 'Origen', key: 'Nombre', idTh: 'firstTh', idTd: 'firstTd' },
      //     { label: 'Fecha de Creación', key: 'FechaActualizacion', idTh: 'firstTh', idTd: 'firstTd' },
      //   ],
      //   data: [
      //   ],
      //   title: 'Embarques de Importación'
      // },

    ]
  }

  componentDidMount = () => {
    this.setState({
      steps: this.props.steps,
      allSteps: this.props.allSteps,
      HBL_HAWB: this.props.HBL_HAWB,
      ShipmentNumber: this.props.ShipmentNumber,
      Status: this.props.Status,
      logoUrl: this.props.logoUrl,
      customerName: this.props.customerName,
      Grupo: this.props.Grupo
    }, () => {
      this.createTables();
    });
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      steps: nextProps.steps,
      allSteps: nextProps.allSteps,
      HBL_HAWB: nextProps.HBL_HAWB,
      ShipmentNumber: nextProps.ShipmentNumber,
      Status: nextProps.Status,
      logoUrl: nextProps.logoUrl,
      customerName: nextProps.customerName,
      Grupo: nextProps.Grupo
    }, () => { this.createTables(); });
  }

  createTables = () => {
    var allTables = [];
    this.state.allSteps.map((e) => {
      var findTable = false;
      allTables.map((f) => {
        if (f.eventType === e.EventType) {
          f.data.push(e);
          findTable = true;
        }
        return f;
      });
      if (!findTable) {
        var obj = {
          eventType: e.EventType,
          data: [e]
        };
        allTables.push(obj);
      }
      return e;
    });
    this.setState({ allTables: allTables });
  }

  render() {
    let { cliente, NIT, Grupo } = this.state;

    return (
      <>
        <Card className="myCard">
          <CardBody>

            <StepperEvent steps={this.state.steps} />

          </CardBody>
        </Card>
        <Card className="myCard">
          <CardBody  >
            {this.state.allTables.length > 0 ? 
            <TablesEvent headerClass="headerTable"
             colorHeader={'#000a2e'} columns={this.state.columns} allTables={this.state.allTables} /> :
              this.state.tables.map((e, key) => {
                return (
                  <div key={key}>
                    <div className="col-12" key={key}>
                      <div className="row">
                        <div className="col-12">
                          <legend style={{ color: '#000a2e', opacity: '87%'}}>{e.title}</legend>
                        </div>
                        <div className="col-12">
                          <div className="table_container">
                            <Table

                              columns={e.columns} styleColumn={true} data={e.data} title={e.title}
                              options={{
                                isEvent: true,
                                styleColumn: true,
                                large: false,
                                downloads: {
                                  pdf: false,
                                  xlsx: false
                                }
                              }} />
                          </div>
                        </div>
                      </div>

                    </div>
                    <div style={{ height: 40 }}></div>
                  </div>
                );
              })
            }
          </CardBody>
        </Card>
      </>
    );
  }
}

export default withNamespaces()(Events);
